import React from 'react'
import PropTypes from 'prop-types'
import { AddMemberBankAccountForm } from '../../shared/components'

const AddBeneficiaryBankAccountComponent = ({ onSubmit }) => {
  return (
    <AddMemberBankAccountForm header="Add bank account" onSubmit={onSubmit} />
  )
}

AddBeneficiaryBankAccountComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default AddBeneficiaryBankAccountComponent
